import React from 'react';
export var useOnUpdate = function useOnUpdate(listener, deps) {
  var memo = React.useRef(deps);
  React.useEffect(function () {
    if (!deps) {
      return listener();
    } else if (deps.some(function (v, i) {
      return v !== memo.current[i];
    })) {
      memo.current = deps;
      return listener();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, deps);
};